export { default as InternalAppSwitcher } from './internal-app-switcher';
